import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Button } from "reactstrap";

// Components
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import GlobalCreateMemberAction from "../CommonForBoth/TopbarDropdown/GlobalCreateMemberAction";
import GlobalMemberSearch from "../CommonForBoth/TopbarDropdown/GlobalMemberSearch";
import GlobalTVAction from "../CommonForBoth/TopbarDropdown/GlobalTVAction";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import withRouter from "../Common/withRouter";

// Images & Styles
import neoLogo from "../../assets/images/Neo_Logo_A.svg";
import "./NeoHeader.css";

// Hooks
import { useLayout } from "../../hooks/useLayout";

/**
 * NeoHeader
 * Header limpo e minimalista, alinhado ao sidebar dark.
 * No desktop: apenas ações no lado direito (logo está no sidebar).
 * No mobile: mostra hamburger + logo à esquerda.
 */
const NeoHeader = (props) => {
  const { toggleSidebar } = useLayout();
  const dashboardLink = "/dashboard";

  return (
    <React.Fragment>
      <header id="page-topbar" className="neo-header">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            {/* Logo visível apenas no mobile (no desktop está no sidebar) */}
            <div className="navbar-brand-box neo-brand-box">
              <Link to={dashboardLink} className="logo d-flex align-items-center justify-content-center">
                <img src={neoLogo} alt="NeoApp" className="neo-header-logo" />
              </Link>
            </div>
            
            {/* Sidebar Toggle Button (Mobile) */}
            <Button 
              size="sm" 
              color="none" 
              type="button" 
              onClick={toggleSidebar} 
              className="px-3 font-size-16 header-item waves-effect d-lg-none" 
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars"></i>
            </Button>
          </div>

          {/* Right Header Actions */}
          <div className="d-flex align-items-center gap-1">
            <GlobalMemberSearch />
            <GlobalTVAction />
            <GlobalCreateMemberAction />
            <NotificationDropdown />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

NeoHeader.propTypes = {
  t: PropTypes.any,
};

export default withRouter(withTranslation()(NeoHeader));
